export default __webpack_public_path__ + "920534d4faad02ee4b07917880d48c43.svg";